import { render, staticRenderFns } from "./commands.vue?vue&type=template&id=7ddc324e&"
import script from "./commands.vue?vue&type=script&lang=js&"
export * from "./commands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports